function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#3c81bf;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:3px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.5 1.5)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M4.916,13.716V3.741A1.17,1.17,0,0,0,3.687,2.494H2.458A2.483,2.483,0,0,1,0,0H0",
  transform: "translate(12.289)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M0,0A8.613,8.613,0,0,0,8.6,8.728h0A8.613,8.613,0,0,0,17.205,0",
  transform: "translate(0 13.716)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M4.916,0h0A2.483,2.483,0,0,1,2.458,2.494H1.229A1.17,1.17,0,0,0,0,3.741v9.975"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "a",
  cx: 4.916,
  cy: 4.988,
  rx: 4.916,
  ry: 4.988,
  transform: "translate(22.121 3.741)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M.75.75h0",
  transform: "translate(26.286 7.978)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M0,8.728V10.6a9.353,9.353,0,0,0,9.217,9.352h0A9.353,9.353,0,0,0,18.434,10.6V0",
  transform: "translate(8.603 13.716)"
}));

function SvgIconDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.952,
    height: 36.667,
    viewBox: "0 0 34.952 36.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoctor);
export default __webpack_public_path__ + "static/media/icon-doctor.b5fadc8f.svg";
export { ForwardRef as ReactComponent };